<template>
  <div>
    <PageHeader
      :page="page"
      has-return
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    />
    <board :details="saee10Info" class="mb-3" />   
    <div v-if="historyResult.length">
        <TimeLine class="mt-4 mx-3">
            <TimeLineItem
                v-for="(row, index) in historyResult"
                :key="index"
                class="custom-time-line rounded"
            >
                <template #icon>
                    <em class="color-white fa-exchange far radius" />
                </template>
                <template #date>
                <div class="date-container">
                    <div class="color-black font-16 font-weight-bold fulldate">
                    {{ formatter(row.date) | date }}
                    <small>{{ formatter(row.date) | hour }}</small>
                    </div>
                </div>
                </template>
                <div class="row">
                    <div class="col-12 col-md-2 flex-column d-flex border-right">
                        <label class="mb-0 px-2 pt-1 font-weight-bold">
                        Cambio de Estatus
                        </label>
                    </div>
                    <div
                        class="d-none d-md-block col-md-1 border-left--color-gray vertical-line"
                    />
                    <div class="col-12 col-md-3 mt-2 flex-column d-flex">
                        <label class="mb-0 color-gray-6 text-small">Usuario:</label>
                        <span class="info-text">{{ row.userRole }}</span>
                    </div>
                    <div class="col-12 col-md-3 mt-2 flex-column d-flex">
                        <label class="mb-0 color-gray-6 text-small">Nombre:</label>
                        <span class="info-text">{{ row.userFullName }}</span>
                    </div>
                    <div class="col-12 col-md-3 mt-2 flex-column d-flex">
                        <label class="mb-0 color-gray-6 text-small">Estatus:</label>
                        <span class="d-flex align-items-baseline">
                        <em
                            class="fa fa-circle pr-2"
                            :style="`color: ${row.statusColor}`"
                        />
                        <span class="info-text">{{ row.statusName }}</span>
                        </span>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="bg-white rounded py-3 px-4">
                        <div class="mb-0 color-gray-6 text-small">
                            <span class="fas fa-info-circle color-orange pr-1" />
                            Descripción:
                        </div>
                        <div class="color-black font-16 mt-2">{{ row.description }}</div>
                        </div>
                    </div>
                </div>
            </TimeLineItem>
        </TimeLine>   
    </div>
    <div v-else>
      <CustomResultNotFound text="No hay información disponible." />
    </div>    
  </div>
</template>

<script>
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import PageHeader from 'PageHeader';
import CustomResultNotFound from 'custom-result-not-found';
import Board from "Board";
import requestTypeCodes from '@/utils/constants/hrrequest/requestTypeCodes';

import { getInformationHeader, getHistory } from '@/modules/peiSAEE/api.js';
import moment from 'moment';

export default {
  name: 'SAEE10History',
  components: {
    TimeLine,
    TimeLineItem,
    PageHeader,
    CustomResultNotFound,
    Board
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Historial de la SAEE 10',
        routes: ['Inicio', 'Recursos Humanos', 'Personal Irregular'],
      },
      saee10Id: null, 
      saee10InfoHeader: {
        peiId: null,
        hrRequestStatus: null,
        requestNumber: null,
        studentSie: null,
        studentName: null,
        studentAge: null,
        studentImpediment: null
      },
      historyResult: [],      
    };
  }, 
  computed:{
    saee10Info() {
      return [
        [
          {
            label: "Número de PEI:",
            data:  this.formatPeiNumber(this.saee10InfoHeader?.peiId),
            icon: "fas fa-address-book",
          },
          {
            label: "Estatus:",
            data: this.saee10InfoHeader?.hrRequestStatus,
            icon: "fas fa-flag",
          },
          {
            label: "Número de SAEE10:",
            data: this.saee10InfoHeader?.requestNumber,
            icon: "fas fa-clipboard-list-check",
          },
          {
            label: "Estudiante:",
            data: `${this.saee10InfoHeader?.studentSie} - ${this.saee10InfoHeader?.studentName}`,
            icon: "fas fa-address-book",
          },
          {
            label: "Edad:",
            data: `${this.saee10InfoHeader?.studentAge}`,
            icon: "fas fa-calendar-edit",
          },
          {
            label: "Impedimento:",
            data: `${this.saee10InfoHeader?.studentImpediment}`,
            icon: "fas fa-clipboard-list-check",
          },
          
        ],
      ];
    }
  },
  methods: {
    async getHistory() {
    
        await getInformationHeader(this.saee10Id).then((res) => {
            this.saee10InfoHeader = res.data;            
        });
        
        await getHistory(this.saee10Id).then((res) => {
            this.historyResult = res.data;
        });
    },    
    formatPeiNumber(peiId) {
      if (peiId) {
        const year = peiId.slice(0, 4);
        const id = peiId.slice(4);

        return `${year}-${id}`;
      }

      return "-";
    },
    formatter(date) {
      return moment(date);
    },
    getStatusCircleColor(statusId) {
        return 'black';
      //return (statusId) => getRequestStatusColor(statusId);
    },
  },
  async mounted() {    
    this.saee10Id = parseInt(this.$route.params.id);
    this.getHistory();    
  },
};
</script>

<style></style>
